// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3rQg4","left":"styles_left__YqntQ"};